import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) {}
  getUser(){
    return this.http.get(`${this.baseUrl}/user/me/view`);
  }
  getBusinessView(businessId){
    return this.http.get(`${this.baseUrl}/business/view/${businessId}`);
  }

  put_resetPassword(data) {
    return this.http.put(`${this.baseUrl}/user/me/changepassword`, data);
  }

  setDefaultAddress(data){
    return this.http.put(`${this.baseUrl}/addressbook/edit`, data);
  }

  createDefaultAddress(data){
    return this.http.post(`${this.baseUrl}/addressbook/create`, data);
  }
}
